var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/moral-guidance.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-8b86d534!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/moral-guidance.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MoralGuidance.vue
// module id = 1330
// module chunks = 1